const ru = {
  localeCode: "ru-RU",
  common: {
    add: "Добавить",
    all: "Все",
    cancel: "Отмена",
    confirm: "Подтвердить",
    delete: "Удалить",
    edit: "Изменить",
    generated: "Создано автоматически",
    none: "Нет",
    reset: "Сбросить",
    restore: "Восстановить",
    save: "Сохранить",
    saveAnyway: "Все равно сохранить",
    view: "Открыть"
  },
  shell: {
    expenseCommandCenter: "Центр управления расходами",
    installApp: "Установить приложение",
    logout: "Выйти",
    mainNavigation: "Главная навигация",
    personalFinance: "Личные финансы",
    themeMode: "Режим темы",
    toggleNavigation: "Открыть или закрыть меню"
  },
  auth: {
    backToSignIn: "Вернуться ко входу",
    confirmPassword: "Подтвердите пароль",
    createAccount: "Создать аккаунт",
    createWorkspace: "Создайте защищенное локальное рабочее пространство",
    email: "Почта",
    fullName: "Полное имя",
    password: "Пароль",
    signIn: "Войти",
    signInSubtitle: "Войдите в рабочее пространство финансов"
  },
  notifications: {
    accountCreated: "Аккаунт создан.",
    actionFailed: "Действие не выполнено.",
    backupDownloaded: "Резервная копия скачана.",
    backupRestored: "Резервная копия восстановлена.",
    backupRestoreFailed: "Не удалось восстановить резервную копию.",
    csvExported: "CSV экспортирован.",
    expenseAdded: "Расход добавлен.",
    expenseDeleted: "Расход удален.",
    expenseDeleteFailed: "Не удалось удалить расход.",
    expenseRestored: "Расход восстановлен.",
    expenseRestoreFailed: "Не удалось восстановить расход.",
    expenseSaveFailed: "Не удалось сохранить расход.",
    expenseUpdated: "Расход обновлен.",
    expenseUpdateFailed: "Не удалось обновить расход.",
    expensesLoadFailed: "Не удалось загрузить расходы.",
    expensesResetFailed: "Не удалось сбросить расходы.",
    goalDeleted: "Цель удалена.",
    goalDeleteFailed: "Не удалось удалить цель.",
    goalReorderFailed: "Не удалось изменить порядок целей.",
    goalRestored: "Цель восстановлена.",
    goalRestoreFailed: "Не удалось восстановить цель.",
    goalSaved: "Цель сохранена.",
    goalSaveFailed: "Не удалось сохранить цель.",
    goalsLoadFailed: "Не удалось загрузить цели.",
    goalsResetFailed: "Не удалось сбросить цели.",
    goalUpdated: "Цель обновлена.",
    goalUpdateFailed: "Не удалось обновить цель.",
    importEmpty: "В этом файле не найдено подходящих расходов.",
    importFailed: "Импорт не выполнен.",
    appInstalled: "LedgerFlow установлено и готово к запуску как приложение.",
    installDismissed: "Установка пропущена. Вы сможете установить LedgerFlow позже.",
    jsonExported: "JSON экспортирован.",
    localDataReset: "Локальные расходы и цели сброшены.",
    passwordTooShort: "Пароль должен быть не короче 8 символов.",
    passwordsDoNotMatch: "Пароли не совпадают.",
    profileRequired: "Имя и почта обязательны.",
    profileSaved: "Профиль сохранен.",
    profileSaveFailed: "Не удалось сохранить профиль.",
    recurringExpensesAdded: (count) => `${count} повторяющихся расходов добавлено.`,
    settingsSaved: "Настройки сохранены.",
    settingsSaveFailed: "Не удалось сохранить настройки.",
    themeSaveFailed: "Не удалось сохранить тему.",
    undo: "ОТМЕНИТЬ",
    welcomeBack: "С возвращением!",
    expensesImported: (count) => `${count} расходов импортировано.`
  },
  dialogs: {
    deleteExpense: {
      confirmLabel: "Удалить",
      message: "Этот расход будет удален. В течение 5 секунд его можно вернуть.",
      title: "Удалить расход?"
    },
    deleteGoal: {
      confirmLabel: "Удалить",
      message: "Эта цель будет удалена. В течение 5 секунд ее можно вернуть.",
      title: "Удалить цель?"
    },
    resetWorkspace: {
      confirmLabel: "Сбросить",
      message: "Это удалит все локальные расходы и цели текущего пользователя.",
      title: "Сбросить рабочее пространство?"
    },
    restoreBackup: {
      confirmLabel: "Восстановить",
      message: "Эта резервная копия заменит текущие локальные расходы, цели и настройки.",
      title: "Восстановить резервную копию?"
    },
    saveBudget: {
      confirmLabel: "Все равно сохранить",
      message: "Бюджет меньше расходов за этот месяц. Все равно сохранить настройки?",
      title: "Сохранить бюджет?"
    }
  },
  dashboard: {
    activeGoals: "Активные цели",
    add: "Добавить",
    addExpenses: "Добавьте расходы",
    addExpense: "Добавить расход",
    addFirstExpense: "Добавить первый расход",
    addExpensesToRenderChart: "Добавьте расходы, чтобы построить график.",
    barChart: "Столбчатый график",
    barsAppearAfterFirstCategory: "Столбцы появятся после первой категории расходов.",
    budgetIsNotSet: "Бюджет не задан",
    budgetProgress: "Прогресс бюджета",
    budgetRemaining: (amount) => `${amount} осталось в бюджете этого месяца.`,
    budgetReached: "Месячный бюджет полностью использован.",
    budgetUsed: "Использовано бюджета",
    categoryBudgets: "Бюджеты категорий",
    categoriesAppear: "Категории появятся после добавления расходов.",
    categoryShare: "Доли категорий",
    categoryTotals: "Итоги по категориям",
    expense: "Расходы",
    financialDashboard: "Финансовая панель",
    firstTransactionHint: "Добавьте первую операцию, и панель начнет показывать аналитику.",
    goals: "Цели",
    goalsHint: "Цели помогают видеть накопления рядом с расходами.",
    income: "Доход",
    incomeMinusExpenses: "Доход минус расходы текущего месяца",
    latestOperations: "Последние операции",
    leftAmount: (amount) => `${amount} осталось`,
    limitsByCategory: "Лимиты по категориям",
    lineChart: "Линейный график",
    livePulse: "Финансовый пульс",
    monthlyHistoryHint: "История по месяцам появится со временем.",
    monthlyIncomePlan: "Плановый доход за месяц",
    monthlyLimit: (amount) => `${amount} лимит на месяц`,
    monthlyPlan: "План на месяц",
    noBarsYet: "Пока нет столбцов",
    noCategoryBudgets: "Нет бюджетов категорий",
    noCategoryData: "Нет данных по категориям",
    noData: "Нет данных",
    noExpensesYet: "Расходов пока нет",
    noGoalsYet: "Целей пока нет",
    noTrendYet: "Тренда пока нет",
    pieChart: "Круговой график",
    recentActivity: "Недавняя активность",
    recurringThisMonth: (count) => `${count} повторяющихся в этом месяце`,
    savingsProgress: "Прогресс накоплений",
    savingsTargets: "Финансовые цели",
    savedAmount: (amount) => `${amount} накоплено`,
    setBudgetHint: "Задайте месячный бюджет, чтобы отслеживать остаток.",
    setCategoryBudgetsHint: "Настройте бюджеты категорий в разделе настроек.",
    sixMonthTrend: "Тренд за шесть месяцев",
    spendingMix: "Структура расходов",
    spentAmount: (amount) => `${amount} потрачено`,
    topCategory: "Главная категория",
    totalBalance: "Общий баланс",
    transactions: "Операции",
    transactionsCount: (count) => `${count} операций`,
    valueOfLimit: (spent, limit) => `${spent} из ${limit}`,
    tuneBudget: "Настроить бюджет"
  },
  expenses: {
    actions: "Действия",
    addExpense: "Добавить расход",
    addFirstExpense: "Добавить первый расход",
    amountColumn: (currency) => `Сумма (${currency})`,
    category: "Категория",
    clearFilters: "Очистить фильтры",
    csv: "CSV",
    date: "Дата",
    endDate: "Дата окончания",
    excel: "Excel",
    expenses: "Расходы",
    import: "Импорт",
    json: "JSON",
    maxAmount: "Макс. сумма",
    minAmount: "Мин. сумма",
    name: "Название",
    needCleanSlate: "Нужно начать заново?",
    noExpensesFound: "Расходы не найдены",
    noExpensesYet: "Расходов пока нет",
    noMatches: "По этим фильтрам ничего не найдено.",
    pdf: "PDF",
    periodFilters: {
      all: "Все",
      today: "Сегодня",
      week: "Неделя",
      month: "Месяц",
      year: "Год"
    },
    priority: "Приоритет",
    receipt: "Чек",
    repeat: "Повтор",
    resetAllLocalData: "Сбросить локальные данные",
    search: "Поиск",
    searchPlaceholder: "Искать расходы",
    startDate: "Дата начала",
    tags: "Теги",
    transactions: "Операции",
    firstExpenseHint: "Добавьте первую операцию, и LedgerFlow начнет строить аналитику."
  },
  goals: {
    addGoal: "Добавить цель",
    createFirstGoal: "Создать первую цель",
    daysLeft: (days) => `${days} дней осталось`,
    delete: "Удалить",
    edit: "Изменить",
    financialTargets: "Финансовые цели",
    goals: "Цели",
    noGoalsYet: "Целей пока нет",
    target: (date) => `Цель: ${date}`,
    targetDatePassed: "Дата цели прошла",
    emptyHint: "Создайте цель и отслеживайте прогресс рядом с ежедневными расходами."
  },
  reports: {
    addExpensesForReport: "Добавьте расходы, чтобы заполнить отчет.",
    breakdown: "Разбивка",
    categories: "Категории",
    comparison: "Сравнение",
    largestSpendAreas: "Крупнейшие статьи расходов",
    monthTotals: "Итоги по месяцам",
    monthlyReadout: "Месячный отчет",
    monthlyTotalsHint: "Итоги по месяцам появятся со временем.",
    noCategoriesYet: "Категорий пока нет",
    noMonthlyTotalsYet: "Итогов по месяцам пока нет",
    noPriorityDataYet: "Данных по приоритетам пока нет",
    prioritiesHint: "Приоритеты появятся после добавления расходов.",
    priorityPressure: "Нагрузка по приоритетам",
    reports: "Отчеты"
  },
  settings: {
    accentColor: "Акцентный цвет",
    appearance: "Внешний вид",
    backupAndRestore: "Резервная копия и восстановление",
    budgetAndIncome: "Бюджет и доход",
    budgetsAndOrder: "Бюджеты и порядок",
    categoryLimits: "Лимиты категорий",
    currencies: "Валюты",
    dangerZone: "Опасная зона",
    data: "Данные",
    displayCurrency: "Валюта отображения",
    downloadBackup: "Скачать резервную копию",
    dragCategories: "Перетаскивайте категории для изменения порядка",
    editableExchangeRates: "Редактируемые курсы",
    fontSize: "Размер шрифта",
    language: "Язык",
    localeAndDisplay: "Язык и отображение",
    monthlyBudget: "Месячный бюджет",
    monthlyIncome: "Месячный доход",
    plan: "План",
    preferences: "Предпочтения",
    ratePerUsd: (currency) => `${currency} за 1 USD`,
    ratesHint: "Курсы хранятся локально и используются для пересчета каждого расхода в валюту отображения.",
    resetLocalData: "Сбросить локальные данные",
    resetWorkspace: "Сбросить рабочее пространство",
    restoreBackup: "Восстановить резервную копию",
    saveSettings: "Сохранить настройки",
    settings: "Настройки",
    theme: "Тема",
    workspaceControls: "Управление рабочим пространством",
    dangerHint: "Это удалит все локальные расходы и цели текущего пользователя."
  },
  profile: {
    accountIdentity: "Профиль аккаунта",
    details: "Детали",
    email: "Почта",
    firstSession: "Первая сессия",
    lastLogin: "Последний вход",
    name: "Имя",
    personalInformation: "Личная информация",
    profile: "Профиль",
    saveProfile: "Сохранить профиль",
    uploadAvatar: "Загрузить аватар",
    yourProfile: "Ваш профиль"
  },
  expenseForm: {
    addTitleAndAmount: "Добавьте название и положительную сумму.",
    amount: (currency) => `Сумма (${currency})`,
    cancel: "Отмена",
    category: "Категория",
    date: "Дата",
    description: "Описание",
    editExpense: "Изменить расход",
    name: "Название",
    namePlaceholder: "Продукты, аренда, подписка...",
    newExpense: "Новый расход",
    optionalNote: "Необязательная заметка",
    priority: "Приоритет",
    receipt: "Чек",
    receiptTooLarge: "Чек должен быть меньше 2 МБ для локального хранения.",
    removeReceipt: (name) => `Удалить ${name}`,
    repeat: "Повтор",
    save: "Сохранить",
    tags: "Теги"
  },
  goalForm: {
    addTitleAndTarget: "Добавьте название и положительную целевую сумму.",
    cancel: "Отмена",
    currentProgress: "Текущий прогресс",
    description: "Описание",
    editGoal: "Изменить цель",
    goalTitle: "Название цели",
    goalPlaceholder: "Отпуск, новый ноутбук, резервный фонд",
    newGoal: "Новая цель",
    save: "Сохранить",
    targetAmount: "Целевая сумма",
    targetDate: "Дата цели",
    whyItMatters: "Почему эта цель важна"
  },
  insights: {
    addExpensesPatterns: "Добавьте расходы, чтобы увидеть закономерности.",
    budgetAlertsHint: "Задайте месячный бюджет, чтобы получать бюджетные подсказки.",
    budgetHealth: "Состояние бюджета",
    categoryAlerts: "Предупреждения по категориям",
    categoryBudgetOk: "Бюджеты категорий сейчас под контролем.",
    leftInBudget: (amount) => `${amount} осталось в месячном бюджете.`,
    monthlyPace: "Темп месяца",
    newBaseline: "Новая база",
    newBaselineDetail: "Этот месяц станет точкой сравнения.",
    noData: "Нет данных",
    notSet: "Не задан",
    overBudget: (categories) => `${categories} выше бюджета.`,
    recurringDetail: "Автоматически созданные и повторяющиеся расходы этого месяца.",
    recurringLoad: "Повторяющаяся нагрузка",
    spendingAbove: "Расходы выше прошлого месяца.",
    spendingBelow: "Расходы ниже прошлого месяца.",
    spentThisMonth: (amount) => `${amount} потрачено в этом месяце.`,
    topCategory: "Главная категория"
  },
  onboarding: {
    budgets: "Контролируйте бюджет",
    getStarted: "Начать",
    goals: "Достигайте финансовых целей",
    intro: "Управляйте расходами, бюджетом и финансовыми целями в одном приложении.",
    title: "Добро пожаловать в LedgerFlow",
    track: "Отслеживайте доходы и расходы"
  },
  options: {
    menu: {
      dashboard: "Панель",
      expenses: "Расходы",
      goals: "Цели",
      reports: "Отчеты",
      profile: "Профиль",
      settings: "Настройки"
    },
    categories: {
      "Food & Dining": "Еда и кафе",
      Transportation: "Транспорт",
      Housing: "Жилье",
      Shopping: "Покупки",
      Entertainment: "Развлечения",
      Healthcare: "Здоровье",
      Other: "Другое"
    },
    priorities: {
      Low: "Низкий",
      Medium: "Средний",
      High: "Высокий",
      Critical: "Критический"
    },
    frequencies: {
      "One-time": "Один раз",
      Daily: "Ежедневно",
      Weekly: "Еженедельно",
      Monthly: "Ежемесячно",
      Yearly: "Ежегодно"
    },
    tags: {
      Essential: "Важное",
      Business: "Бизнес",
      Personal: "Личное",
      Family: "Семья",
      Travel: "Путешествия",
      Subscription: "Подписка",
      Optional: "Необязательное"
    },
    themeModes: {
      auto: "Авто",
      light: "Светлая",
      dark: "Темная"
    },
    fontSizes: {
      compact: "Компактный",
      comfortable: "Комфортный",
      large: "Крупный"
    },
    languages: {
      EN: "Английский",
      RU: "Русский",
      TR: "Турецкий"
    },
    accentThemes: {
      "#2563eb": "Синий",
      "#0f766e": "Бирюзовый",
      "#0f8a5f": "Изумрудный",
      "#b7791f": "Янтарный",
      "#be123c": "Розовый"
    }
  }
};

export default ru;
